import React, { useEffect, useState, createContext, useContext } from 'react';
import { onboardingPortal } from '../../../api/OrgController';
import { OnboardingPortalWithOrgs } from '../../../api/OrgController/onboardingPortal';

type OrgOnboardingSelectContextProviderProps = {
  onboardingPortalHash: string;
};

type OrgOnboardingSelectContextValue = {
  onboardingPortalHash?: string;
  portalConfig?: OnboardingPortalWithOrgs;
  selectedOrg?: string;
  setSelectedOrg?: (id: string) => void;
};

export const OrgOnboardingSelectContext =
  createContext<OrgOnboardingSelectContextValue>({});
export const useOrgOnboardingSelectContext = () =>
  useContext(OrgOnboardingSelectContext);

export const OrgOnboardingSelectContextProvider: React.FC<
  OrgOnboardingSelectContextProviderProps
> = props => {
  const { onboardingPortalHash: hash, children } = props;

  const [portalConfig, setPortalConfig] =
    useState<OnboardingPortalWithOrgs | null>(null);

  useEffect(() => {
    const fetchPortal = async () => {
      const portal = await onboardingPortal(hash);
      setPortalConfig(portal);
    };
    fetchPortal();
  }, [hash]);

  const [selectedOrg, setSelectedOrg] = useState<string>();

  return (
    <OrgOnboardingSelectContext.Provider
      value={{
        onboardingPortalHash: hash,
        portalConfig,
        selectedOrg,
        setSelectedOrg,
      }}
    >
      {children}
    </OrgOnboardingSelectContext.Provider>
  );
};
